import isEmpty from "lodash-es/isEmpty"
import isNumber from "lodash-es/isNumber"
import map from "lodash-es/map"
import { DateTime } from "luxon"

import type { ISessionExtraPartyModel } from "@/3514/types"

import { ESessionInfoColorSchema as EColorSchema, TSessionInfoExtraPartyData } from "./session-info.types"

function getIsSwapSessionVisibleBasedOnDate(isoTime: string): boolean {
    return DateTime.fromISO(isoTime).isValid
        ? DateTime.fromISO(isoTime).toMillis() >= DateTime.now().plus({ seconds: 60 }).toMillis()
        : false
}

function getFormattedDate(isoTime: string): string {
    return DateTime.fromISO(isoTime).isValid
        ? DateTime.fromISO(isoTime).toFormat("MMM d, h:mma").replace("AM", "am").replace("PM", "pm")
        : String("")
}

function isEnoughTimeToEdit(startTimeISO: string, hoursBuffer: number): boolean {
    return DateTime.fromISO(startTimeISO).diff(DateTime.now(), "hours").hours >= hoursBuffer
}

export default {
    getIsSwapSessionVisibleBasedOnDate,
    getFormattedDate,
    isEnoughTimeToEdit
}

function getSessionInfoColorSchema(params: { isLive: boolean; isMissed: boolean; isCancelled: boolean }): EColorSchema {
    if (params.isLive) return EColorSchema.AccentBorderWhiteBg

    if (params.isMissed) return EColorSchema.OrangeBorderWhiteBg

    if (params.isCancelled) return EColorSchema.TransparentBorderBlueBg

    return EColorSchema.BlueBorderWhiteBg
}

function mapSessionExtraPartyModelsToSessionInfoExtraParties(
    models: ISessionExtraPartyModel[]
): TSessionInfoExtraPartyData[] {
    return isEmpty(models)
        ? []
        : map<ISessionExtraPartyModel, TSessionInfoExtraPartyData>(
              models,
              (e: ISessionExtraPartyModel): TSessionInfoExtraPartyData => ({
                  id: !isNumber(e.id) ? 0 : e.id,
                  email: isEmpty(e.email) ? null : e.email,
                  firstName: isEmpty(e.firstName) ? null : e.firstName,
                  lastName: isEmpty(e.lastName) ? null : e.lastName,
                  label: isEmpty(e.label) ? null : e.label,
                  role: e.role,
                  attendanceStatus: isEmpty(e.attendanceStatus) ? null : e.attendanceStatus,
                  invitationStatus: isEmpty(e.invitationStatus) ? null : e.invitationStatus
              })
          )
}

export {
    getSessionInfoColorSchema,
    mapSessionExtraPartyModelsToSessionInfoExtraParties,
    getFormattedDate as getSessionInfoFormattedDate
}
